module.exports = __webpack_public_path__ + "img/portfolio.f0fbfa59.svg";